export default __webpack_public_path__ + "static/media/boris.83de7251.jpg";